<template>
<!-- 搜索律师 -->
  <div class="bgf8">
      <div class="pt40">
        <seafirmsmenu />
      </div>
      <seafirmscont />
  </div>
</template>

<script>
import seafirmsmenu from 'views/seafirms/child/seafirmsmenu'
import seafirmscont from './child/sealawscont'
export default {
    components:{
        seafirmsmenu,
        seafirmscont
    }
}
</script>

<style lang="scss" scoped>
.bgf8{
    background-color: #F8F8F8;
    .pt40{
        padding-top: 40px;
    }
}
</style>